import { ajaxCall } from "./ajax-call";

const buyButtons = async () => {
    const buyButtons = document.querySelectorAll(
        ".js-ajax-buy-button"
    );

    await Promise.all([...buyButtons].map((button) => {
        if(!button.dataset.isbn) {
            return;
        }

        return ajaxCall(button.dataset.isbn, button, 'upt_ajax_buy_button');
    }));
};

document.addEventListener("DOMContentLoaded", () => {
    buyButtons();
}); 